import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';

import { dataTransform } from '@nexio/emvio-util-app';
import * as utilApp from '@nexio/emvio-util-app';
import {
    fetchUrl,
    getBatches as fetchBatches
} from './batchesActions';
import {
    getBatches,
    getCount,
    getPages,
    getBatchesErrorMessage,
    getIsBatchesLoading
} from './batchesEntity';
import { goToBatchOfTransactions } from '../Transactions/transactionsActions';
import BatchesListItem from './BatchesListItem/BatchesListItem';
import ColorDollarAmountCell from '../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import AmountFilter from '../Table/Filters/AmountFilter/AmountFilter';
import { transformDateCell } from '../../utils/cell';
import Table from '../Table/Table';
import FilterWithMapper from '../Table/Filters/FilterWithMapper/FilterWithMapper';
import { getCustomAccess } from '../Self/selfEntity';
import { doesRoleHaveAccessToFeature } from '../../utils/customRole';
import config from '../../config/config';
import InPageMerchantSelector from '../MerchantSelector/InPageMerchantSelector';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { getSelf } from '../Self/selfEntity';

export const defaultColumnsAndProps = [
    {
        accessor: 'merchantName',
        filterable: false,
        label: 'Merchant',
        minWidth: 150,
        show: true,
        sortable: false
    },
    {
        accessor: 'closeDate',
        Cell: transformDateCell,
        transformData: dataTransform.dateTimezoneButHideTimezone,
        transformType: 'dateTimezoneButHideTimezone',
        defaultSortDesc: true,
        filterable: false,
        label: 'Date',
        minWidth: 100,
        show: true
    },
    {
        accessor: 'count',
        className: ['right-justify'],
        filterable: false,
        sortable: false,
        label: 'Count',
        minWidth: 100,
        show: true,
        Cell: (props) => (props.value === 0 ? <span>Error</span> : <span>{props.value}</span>)
    },
    {
        accessor: 'settledAmount',
        Cell: (props) => <ColorDollarAmountCell amount={props.value} />,
        className: ['right-justify'],
        Filter: ({ filter, onChange }) => (<AmountFilter filter={filter} onChange={onChange} />),
        label: 'Amount',
        minWidth: 150,
        show: true
    },
    {
        accessor: 'status',
        Cell: (props) => _.get(utilApp.batchStatusMapper, props.value, '').toUpperCase(),
        Filter: ({ filter, onChange }) => (<FilterWithMapper filter={filter} mapper={_.omit(utilApp.batchStatusMapper, utilApp.batchStatus.open)} onChange={onChange} />),
        sortable: false,
        label: 'Status',
        minWidth: 150,
        show: true
    },
    {
        accessor: 'achDetailId',
        sortable: false,
        label: 'Deposit Detail ID',
        minWidth: 180,
        show: true
    },
    {
        accessor: 'processor.batchRef',
        excelStringField: true,
        label: 'Processor Batch ID',
        minWidth: 175,
        show: true
    },
    {
        accessor: 'merchantId',
        excelStringField: true,
        filterable: false,
        label: 'Merchant ID',
        minWidth: 145,
        show: false
    }
];

export class Batches extends Component {
    static propTypes = {
        customAccess: PropTypes.any
    };

    handleClickRow(history, row, newTab) {
        goToBatchOfTransactions(row.achDetailId, history, newTab, row.closeDate);
    }

    render() {
        let selectRowFunc;
        let columnsAndProps = _.cloneDeep(defaultColumnsAndProps);
        if (doesRoleHaveAccessToFeature(this.props.customAccess, { [config.serviceArns.transaction]: ['GET/v3'] })) {
            selectRowFunc = this.handleClickRow;

            columnsAndProps = columnsAndProps.map((column) => {
                column.className = _.union(['cursor-pointer'], column.className);

                return column;
            });
        }

        const dateKey = 'closeDate';

        return (
            <>
                {this.props.flags?.resellerPhase1 && this.props.self?.accountType === 'RESELLER' && <InPageMerchantSelector />}
                <Table
                    className="emvio-batches-table"
                    dateKey={dateKey}
                    defaultColumnsAndProps={columnsAndProps}
                    defaultSorted={[{
                        desc: true,
                        id: dateKey
                    }]}
                    fetchUrl={fetchUrl}
                    fetchData={fetchBatches}
                    countSelector={getCount}
                    dataSelector={getBatches}
                    errorMessageSelector={getBatchesErrorMessage}
                    hasNoCount={true}
                    isDataLoadingSelector={getIsBatchesLoading}
                    pagesSelector={getPages}
                    itemKey="id"
                    ListItemComponent={BatchesListItem}
                    merchantIdKey="merchantId"
                    noDataText="No Batches Found"
                    selectRow={selectRowFunc}
                    shouldUseGlobalDate
                    uniqueTableName="Batches"
                    filterable={true}
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        customAccess: getCustomAccess(state),
        self: getSelf(state)
    };
}

export default withLDConsumer()(connect(mapStateToProps)(Batches));

